import styles from "./styles.module.css";

export type HeaderTitleProps = {
  icon: string,
  title: string;
  subtitle?: string;
};

export function HeaderTitle({ icon, title, subtitle }: HeaderTitleProps) {
  return (
    <div className={styles.wrapper}>
      <div>
        <div className="d-sm-flex align-items-center justify-content-between">
          <h1 className={styles.title + ' mb-0 text-gray'} ><i className={'pi ' + icon} style={{ fontSize: '2rem', paddingRight: '10px' }}></i>{title}</h1>
        </div>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
    </div>
    
  );
}
